import { NgModule } from '@angular/core';
import { PopupService, UTabViewModule, UGalleriaModule } from '@local/ui-infra';
import { TelemetryHelperService } from '../../services';
import { ResultsModule } from '../results/results.module';
import { CalendarWidgetItemComponent } from './components/calendar-widget-item/calendar-widget-item.component';
import { HomeTabComponent } from './components/home-tab/home-tab.component';
import { TabsViewWrapperComponent } from './components/tabs-view-wrapper/tabs-view-wrapper.component';
import { WidgetNoResultComponent } from './components/widget-no-result/widget-no-result.component';
import { WidgetTitleComponent } from './components/widget-title/widget-title.component';
import { HomePageComponent } from './home-page.component';
import { WidgetsService } from './services/widgets.service';
import { ActionsWidgetComponent } from './widgets/actions-widget/actions-widget.component';
import { CalendarWidgetComponent } from './widgets/calendar-widget/calendar-widget.component';
import { CollectionWidgetComponent } from './widgets/collection-widget/collection-widget.component';
import { FavoritesWidgetComponent } from './widgets/favorites-widget/favorites-widget.component';
import { MailWidgetComponent } from './widgets/mail-widget/mail-widget.component';
import { RecentsWidgetComponent } from './widgets/recents-widget/recents-widget.component';
import { SharedWithMeComponent } from './widgets/shared-with-me/shared-with-me.component';
import { WorkingOnComponent } from './widgets/working-on/working-on.component';
import { PostWidgetComponent } from './widgets/post-widget/post-widget.component';
import { PostWidgetService } from './services/post-widget.service';
import { CreatePostPopupComponent } from './components/create-post-popup/create-post-popup.component';
import { GridstackModule } from 'gridstack/dist/angular';
import { GridComponent } from './widgets/grid/grid.component';
import { CollectionsPageModule } from '../collections-page/collections-page.module';
import { WebSearchModule } from '../web-search/web-search.module';
import { HeaderWidgetComponent } from './widgets/header-widget/header-widget.component';
import { HeaderWidgetService } from './services/header-widget.service';
import { HomeSearchPopupModule } from '../home-search-popup/search-popup.module';
import { AssistantPageModule } from '../settings/components/assistant-page/assistant-page.module';

@NgModule({
  declarations: [
    HomePageComponent,
    RecentsWidgetComponent,
    FavoritesWidgetComponent,
    ActionsWidgetComponent,
    CalendarWidgetComponent,
    CalendarWidgetItemComponent,
    WidgetTitleComponent,
    WidgetNoResultComponent,
    SharedWithMeComponent,
    HeaderWidgetComponent,
    WorkingOnComponent,
    CollectionWidgetComponent,
    MailWidgetComponent,
    PostWidgetComponent,
    HomeTabComponent,
    TabsViewWrapperComponent,
    CreatePostPopupComponent,
    GridComponent,
  ],
  imports: [
    CollectionsPageModule,
    GridstackModule,
    ResultsModule,
    UGalleriaModule,
    UTabViewModule,
    WebSearchModule,
    AssistantPageModule,
    HomeSearchPopupModule,
  ],
  providers: [
    WidgetsService,
    PostWidgetService,
    HeaderWidgetService,
    { provide: PopupService, useClass: PopupService },
    { provide: TelemetryHelperService, useClass: TelemetryHelperService },
  ],
})
export class HomePageModule {}
